import React from 'react';
import i18n from '../../i18n';
import { RefreshCw, Trophy, Medal, Award, ChevronDown, ChevronUp, Users } from 'lucide-react';
import { SaudiRiyalLogo } from '../logo/saudiLogo';

export class BiddersPosition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadMore: false,
    };
  }

  getRankIcon = (position) => {
    switch (position) {
      case 1:
        // return <Trophy size={20} className="rank-icon gold" />;
        return <span size={20} className="rank-number gold" >{position}</span>;

      case 2:
        // return <Medal size={20} className="rank-icon silver" />;
        return <span size={20} className="rank-number silver" >{position}</span>;
      case 3:
        // return <Award size={20} className="rank-icon bronze" />;
        return <span size={20} className="rank-number bronze" >{position}</span>;
      default:
        return <span className="rank-number">{position}</span>;
    }
  };

  render() {
    let top_bidders = this.props.top_bidders;
    let user = this.props.user;

    return (
      <div className="modern-bidders-position">
        <style jsx>{`
          .modern-bidders-position {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            margin-top: 1.5rem;
              font-size: 0.8rem;

          .bidders-card {
            background: white;
            border-radius: 20px;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid #e2e8f0;
            overflow: hidden;
            position: relative;
            margin-bottom: 20px;

          }

          .bidders-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 50%, #92400e 100%);
          }

          .card-header {
            background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
            padding: 1.5rem;
            border-bottom: 1px solid #f3f4f6;
          }

          .header-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .header-title {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            color: #92400e;
            font-weight: 700;
            font-size: 1.1rem;
          }

          .refresh-btn {
            background: white;
            border: 2px solid #f59e0b;
            border-radius: 12px;
            padding: 0.5rem 1rem;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-weight: 600;
            color: #92400e;
            font-size: 0.9rem;
          }

          .refresh-btn:hover {
            background: linear-gradient(135deg, #f59e0b, #d97706);
            color: white;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
          }

          .refresh-icon {
            transition: transform 0.5s ease;
          }

          .refresh-icon.spinning {
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          .card-body {
            padding: 0;
          }

          .bidders-table {
            width: 100%;
            border-collapse: collapse;
          }

          .table-header {
            background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
            border-bottom: 2px solid #e2e8f0;
          }

          .table-header th {
            // padding: 1rem 1.5rem;
            font-weight: 600;
            color: #374151;
            font-size: 0.7rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            background-color: white;
          }

          .bidder-row {
            border-bottom: 1px solid #f1f5f9;
            transition: all 0.3s ease;
            position: relative;
          }

          .bidder-row:hover {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          }

          .bidder-row.current-user {
            background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
            border-left: 4px solid #f59e0b;
          }

          .bidder-row.current-user:hover {
            background: linear-gradient(135deg, #fde68a 0%, #fcd34d 100%);
          }

          .table-cell {
            padding: 1.25rem 1.5rem;
            vertical-align: middle;
          }

          .bidder-info {
            display: flex;
            align-items: center;
            gap: 0.75rem;
          }

          .bidder-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: linear-gradient(135deg, #667eea, #764ba2);
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: 700;
            font-size: 0.9rem;
          }

          .bidder-name {
            font-weight: 600;
            color: #1e293b;
            font-size: 0.95rem;
          }

          .current-user .bidder-name {
            color: #92400e;
            font-weight: 700;
          }

          .rank-container {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .rank-badge {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 0.75rem;
            border-radius: 12px;
            font-weight: 600;
            font-size: 0.85rem;
          }

          .rank-badge.gold {
            background: linear-gradient(135deg, #fbbf24, #f59e0b);
            color: white;
            box-shadow: 0 4px 12px rgba(251, 191, 36, 0.3);
          }

          .rank-badge.silver {
            background: linear-gradient(135deg, #e5e7eb, #9ca3af);
            color: #374151;
            box-shadow: 0 4px 12px rgba(156, 163, 175, 0.3);
          }

          .rank-badge.bronze {
            background: linear-gradient(135deg, #d97706, #92400e);
            color: white;
            box-shadow: 0 4px 12px rgba(217, 119, 6, 0.3);
          }

          .rank-badge.regular {
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            color: white;
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
          }

          .rank-badge.current {
            background: linear-gradient(135deg, #f59e0b, #d97706);
            color: white;
            box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
            border: 2px solid #fbbf24;
          }

          .rank-icon {
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
          }

          .rank-icon.gold {
            color: #fbbf24;
          }

          .rank-icon.silver {
            color: #9ca3af;
          }

          .rank-icon.bronze {
            color: #d97706;
          }

          .rank-number {
            font-weight: 700;
            font-size: 1rem;
          }

          .bid-amount {
            font-weight: 700;
            font-size: 1rem;
            // color: #059669;
            text-align: center;
            
          }

          .current-user .bid-amount {
            color: #dc2626;
            font-size: 1.1rem;
          }

          .currency-symbol {
            color: #6b7280;
            font-weight: 500;
            margin-right: 0.25rem;
          }

          .expand-controls {
            padding: 1rem 1.5rem;
            text-align: center;
            background: #f8fafc;
            border-top: 1px solid #e2e8f0;
          }

          .expand-btn {
            background: transparent;
            border: none;
            color: #f59e0b;
            font-weight: 600;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin: 0 auto;
            padding: 0.5rem 1rem;
            border-radius: 8px;
            transition: all 0.3s ease;
          }

          .expand-btn:hover {
            background: rgba(245, 158, 11, 0.1);
            transform: translateY(-1px);
          }

          .no-bidders {
            padding: 3rem;
            text-align: center;
            color: #64748b;
          }

          .no-bidders-icon {
            margin: 0 auto 1rem;
            width: 60px;
            height: 60px;
            background: linear-gradient(135deg, #fecaca, #f87171);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #dc2626;
          }

          .no-bidders-text {
            font-size: 1.1rem;
            font-weight: 600;
            color: #dc2626;
          }

          /* Mobile responsive */
          @media (max-width: 768px) {
            .header-content {
              flex-direction: column;
              gap: 1rem;
              align-items: stretch;
            }

            .table-header th {
              padding: 0.75rem 1rem;
              font-size: 0.8rem;
            }

            .table-cell {
              padding: 1rem;
            }

            .bidder-info {
              flex-direction: column;
              text-align: center;
              gap: 0.5rem;
            }

            .bidder-avatar {
              width: 35px;
              height: 35px;
              font-size: 0.8rem;
            }

            .bid-amount {
              font-size: 0.9rem;
            }

            .rank-badge {
              padding: 0.375rem 0.5rem;
              font-size: 0.8rem;
            }
          }

          @media (max-width: 480px) {
            .bidders-card {
              border-radius: 16px;
              margin: 0 0.5rem;
            }

            .card-header {
              padding: 1rem;
            }

            .table-header th,
            .table-cell {
              padding: 0.75rem 0.5rem;
              font-size: 0.8rem;
            }

            .bidder-name {
              font-size: 0.85rem;
            }

            .bid-amount {
              font-size: 0.85rem;
            }
          }

          /* Animation for new entries */
          .bidder-row {
            animation: slideIn 0.5s ease-out;
          }

          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
            }
        `}</style>

        <div className="bidders-card">
          <div className="card-header">
            <div className="header-content">
              <div className="header-title">
                <Trophy size={24} />
                {i18n.t('top_3_bidders')}
              </div>
              <button
                className="refresh-btn"
                onClick={this.props.loadTopBidders}
              >
                <RefreshCw 
                  size={18} 
                  className={`refresh-icon ${this.props.refresh_loading ? 'spinning' : ''}`} 
                />
                {i18n.t('refresh')}
              </button>
            </div>
          </div>

          <div className="card-body">
            {top_bidders && top_bidders.length > 0 ? (
              <>
                <table className="bidders-table">
                  <thead className="table-header">
                   
                      <th style={{ textAlign: 'left' }}>
                        {user.role !== 'U' ? i18n.t('username') : i18n.t('bidder_id')}
                      </th>
                      <th style={{ textAlign: 'center' }}>
                        {i18n.t('rank')}
                      </th>
                      <th style={{ textAlign: 'center' }}>
                        {i18n.t('amount')}
                      </th>
                 
                  </thead>
                  <tbody>
                    {top_bidders.map((item, i) => {
                      const isCurrentUser = item.user_id === user.id;
                      const position = i + 1;
                      const isVisible = i <= 2 || this.state.loadMore;
                      
                      if (!isVisible) return null;

                      return (
                        <tr 
                          key={i} 
                          className={`bidder-row ${isCurrentUser ? 'current-user' : ''}`}
                        >
                          <td className="table-cell" style={{ textAlign: 'left' }}>
                            <div className="bidder-info">
                              <div className="bidder-name">
                                {user.role !== 'U' ? item.username : item.enroll_number}
                              </div>
                            </div>
                          </td>
                          
                          <td className="table-cell" style={{ textAlign: 'center' }}>
                            <div className="rank-container">
                              <div className={`rank-badge ${
                                position === 1 ? 'gold' : 
                                position === 2 ? 'silver' : 
                                position === 3 ? 'bronze' : 'regular'
                              } ${isCurrentUser ? 'current' : ''}`}>
                                {isCurrentUser && (
                                  <span style={{ fontSize: '0.8rem' }}>
                                    {i18n.t('my_rank')}:
                                  </span>
                                )}
                                {this.getRankIcon(position)}
                              </div>
                            </div>
                          </td>
                          
                          <td className="table-cell" style={{ textAlign: 'center' }}>
                            <div className="bid-amount">
                              {item.bid_amount.toLocaleString()} 
                              <span className="currency-symbol"><SaudiRiyalLogo /></span>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {top_bidders.length > 3 && (
                  <div className="expand-controls">
                    <button
                      className="expand-btn"
                      onClick={() => this.setState({ loadMore: !this.state.loadMore })}
                    >
                      {this.state.loadMore ? (
                        <>
                          <ChevronUp size={16} />
                          {i18n.t('collapse')}
                        </>
                      ) : (
                        <>
                          <ChevronDown size={16} />
                          {i18n.t('expand')}
                        </>
                      )}
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="no-bidders">
                <div className="no-bidders-icon">
                  <Users size={30} />
                </div>
                <div className="no-bidders-text">
                  {i18n.t('no_bidders_found')}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}